export default "__VITE_ASSET__BpEdLyKR__"